var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "16px",
    height: "16px",
    viewBox: "0 -1.1 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.85,6.85l3.5-3.5a.49.49,0,0,0-.7-.7l-3.5,3.5A.53.53,0,0,0,9,6.3,2,2,0,0,0,8,6a2,2,0,1,0,2,2,2,2,0,0,0-.3-1A.53.53,0,0,0,9.85,6.85ZM8,9A1,1,0,1,1,9,8,1,1,0,0,1,8,9Zm8-1.31a8,8,0,0,1-2.3,6,.52.52,0,0,1-.71,0l-1.3-1.31a.49.49,0,0,1,.7-.7l.94.93A7,7,0,0,0,15,8H13.5a.5.5,0,0,1,0-1h1.42a7.23,7.23,0,0,0-.58-2,.5.5,0,1,1,.9-.42,7.83,7.83,0,0,1,.7,2.66.45.45,0,0,1,0,.41Zm-11.61,4a.48.48,0,0,1,0,.7l-1.3,1.31a.52.52,0,0,1-.71,0A8,8,0,0,1,0,8c0-.14,0-.27,0-.4a.44.44,0,0,1,0-.1.41.41,0,0,1,0-.16A7.95,7.95,0,0,1,7.91,0L8,0a.4.4,0,0,1,.15,0,7.84,7.84,0,0,1,3.23.73.49.49,0,0,1,.24.66.49.49,0,0,1-.66.24A7.12,7.12,0,0,0,8.5,1.05V2.5a.5.5,0,0,1-1,0V1a7,7,0,0,0-4.45,2,6.93,6.93,0,0,0-2,4H2.5a.5.5,0,0,1,0,1H1a6.92,6.92,0,0,0,1.71,4.58l.94-.93A.48.48,0,0,1,4.35,11.65Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBlack);
export default __webpack_public_path__ + "static/media/DashboardBlack.bbe50186dac4506e7662cc22ca5564fe.svg";
export { ForwardRef as ReactComponent };